import React from 'react';
import { FaMagic, FaEdit, FaTimes } from 'react-icons/fa';
import './ModeSelectionModal.css';

const ModeSelectionModal = ({ isOpen, onClose, onSelectAuto, onSelectEdit, occasionName, thumbnailUrl }) => {
  if (!isOpen) return null;

  return (
    <div className="mode-modal-overlay" onClick={onClose}>
      <div className="mode-modal" onClick={(e) => e.stopPropagation()}>
        <button className="mode-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        {thumbnailUrl && (
          <div className="mode-modal-thumbnail">
            <img src={thumbnailUrl} alt={occasionName} />
          </div>
        )}

        <h3 className="mode-modal-title">{occasionName}</h3>
        <p className="mode-modal-subtitle">How would you like to create your wish?</p>

        <div className="mode-modal-buttons">
          <button className="mode-btn mode-btn-auto" onClick={onSelectAuto}>
            <FaMagic className="mode-btn-icon" />
            <span className="mode-btn-label">Quick Create</span>
            <span className="mode-btn-desc">Type your wish & download instantly</span>
          </button>

          <button className="mode-btn mode-btn-edit" onClick={onSelectEdit}>
            <FaEdit className="mode-btn-icon" />
            <span className="mode-btn-label">Full Editor</span>
            <span className="mode-btn-desc">Customise fonts, colors & position</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModeSelectionModal;
